import React from 'react';
import universal from 'react-universal-component';
import ProductPlaceholder from '@core-ui/product-grid-placeholder';
import { useBRRedesign } from '../../hooks/br-redesign.hook';
import { getProductGridContainerStyles } from './styles';


/**
 * To-Do:
 * When implementing SSR for product-grid, remove react-universal-component wrapper & import product-grid directly
 */


export const ProductGrid = universal(import('../product-grid'), {
  loading: () =>
    <ProductPlaceholder numberOfPlaceholders={useBRRedesign() ? 9 : 8} />
});

export const ProductGridContainer = (): JSX.Element => (
  <div
    className="product-grid-container"
    data-testid="product-grid-container"
    css={getProductGridContainerStyles()}
  >
    <ProductGrid />
  </div>
);

